import {
  NEGATIVE_FILTER_TOKEN,
  SEPARATOR,
} from '@hakimo-ui/hakimo/data-access';
import { ForensicsFilterValues } from '@hakimo-ui/hakimo/types';

export function buildForensicsPayload(
  query: string,
  itemCount: number,
  image?: File,
  filterValues?: ForensicsFilterValues
) {
  const form = new FormData();
  form.append('num_results', itemCount.toString());
  if (image) {
    form.append('image_file', image);
  } else {
    form.append('query', query);
  }
  if (filterValues) {
    if (filterValues.location && filterValues.location.values.length > 0) {
      form.append(
        'locationIds',
        getFilterQuery(
          filterValues.location.values.map((v) => v.id),
          filterValues.location.negative
        )
      );
    }

    if (filterValues.camera && filterValues.camera.values.length > 0) {
      form.append(
        'cameraIds',
        getFilterQuery(
          filterValues.camera.values.map((v) => v.id),
          filterValues.camera.negative
        )
      );
    }

    const { startTime, endTime } = filterValues.dateTime;

    if (startTime) {
      const ts = Math.floor(
        new Date(
          typeof startTime === 'string' ? startTime : Number(startTime)
        ).getTime() / 1000
      );
      form.append('start_timestamp_utc', ts.toString());
    }

    if (endTime) {
      const ts = Math.floor(
        new Date(
          typeof endTime === 'string' ? endTime : Number(endTime)
        ).getTime() / 1000
      );
      form.append('end_timestamp_utc', ts.toString());
    }
  }
  return form;
}

function getFilterQuery(values: string[], negative: boolean): string {
  const q = [...values];
  if (negative) {
    q.push(NEGATIVE_FILTER_TOKEN);
  }
  return q.join(SEPARATOR);
}
